export default __webpack_public_path__ + "static/media/class_x.c056e9dc.png";